import { useMutation } from '@apollo/client/react';
import { UPDATE_REQUEST_COMMENT_MUTATION } from './useUpdateRequestCommentMutation.gql';
export const useUpdateRequestCommentMutation = () => {
  return useMutation(UPDATE_REQUEST_COMMENT_MUTATION);
};
